import { ExtlogService } from './../../../services/extlog/extlog.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { BreadCrumbModel } from 'app/views/campaign-3/models/campaign-3-breadcrumb.model';
import { FormGroup,  FormBuilder, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/primeng';
import {Extlog, ExtlogDetail} from 'app/models/extlog.model';
import { KontableComponent } from 'app/modules/UIKit/components/kontable/kontable.component';
import { Campaign3KontableComponent } from 'app/views/campaign-3/components/campaign-3-kontable/campaign-3-kontable.component';
import { CalendarTranslateService } from 'app/modules/UIKit/services/calendarTranslate.service';
import { KvCalendarComponent } from 'app/modules/UIKit/components/kv-calendar/kv-calendar.component';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-extlog',
  templateUrl: './extlog.component.html',
  styleUrls: ['./extlog.component.css']
})
export class ExtlogComponent implements OnInit {
  breadcrumbs: Array<BreadCrumbModel> = [];
  dateRangeForm: FormGroup;
  statusList: Array<SelectItem> = [];
  paginationType = Campaign3KontableComponent.ServerPagination;
  selectFilter = KontableComponent.SelectFilter;
  noFilter = KontableComponent.NoFilter;
  invalidSubmit = false;
  pageSubject = "extlog";
  logDetails: ExtlogDetail[];

  @ViewChild('dateStartField') dateStartField: KvCalendarComponent;
  @ViewChild('dateEndField') dateEndField: KvCalendarComponent;

  constructor(
    public extlogService: ExtlogService,
    private translate: TranslateService,
    private fb: FormBuilder,
    public srvCalendar: CalendarTranslateService
  ) { }

  ngOnInit() {
    this.initBreadCrumbs();
    this.initForm();
    this.initStatusList();
  }

  initBreadCrumbs() {
    let bc1 = new BreadCrumbModel();
    bc1.code = "bc1";
    bc1.description = "Log";
    this.breadcrumbs.push(bc1);
  }

  initForm() {
    this.dateRangeForm = this.fb.group({
      startDate: [null, Validators.required],
      endDate: [null, Validators.required]
    });
  }

  initStatusList() {
    this.statusList.push({ value: null, label: "" });
    this.extlogService.getExtLogStatus().subscribe(res => {
      res.forEach(el => this.statusList.push({ value: el.code, label: el.description }))
    });
  }

  clearDateFilters() {
    this.dateRangeForm.reset();
    this.dateStartField.clearInputField();
    this.dateEndField.clearInputField();
  }

  getStatusDotClass(row: Extlog): string {
    switch (row.extlogStatusCode) {
      case "SUCCESS":
        return "status-dot-green-border";
      case "IN_PROGRESS":
        return "status-dot-green";
      case "ERROR":
        return "status-dot-red";
      default:
        return "";
    }
  }

  getStatusDescription(row: Extlog): string {
    return this.statusList.find(st=> st.value === row.extlogStatusCode).label;
  }

  downloadLogFile(id: number) {
    this.extlogService.getLog(id).subscribe((response: string) => {
      // Create a blob with the response string
      const blob = new Blob([response], { type: 'text/plain' });
      // Create a link element
      const link = document.createElement('a');
      // Set the download attribute with a filename
      link.download = `log_${id}.txt`;
      // Create an object URL for the Blob
      link.href = window.URL.createObjectURL(blob);
      // Append the link to the document body
      document.body.appendChild(link);
      // Programmatically click the link to trigger the download
      link.click();
      // Remove the link from the document
      document.body.removeChild(link);
    });
  }

  getLogDetails(row: Extlog) {
    this.extlogService.getLogDetails(row.id).subscribe(res => {
      this.logDetails = res;
    })
  }

}



// WEBPACK FOOTER //
// ./src/app/views/extlog/extlog/extlog.component.ts